import SectionHeader from './SectionHeader';

export default function ExperienceSection({ data, template, accent }) {
  if (!data.experience || data.experience.length === 0) return null;

  return (
    <div className="resume-section">
      <SectionHeader template={template} accent={accent}>Experience</SectionHeader>
      <div style={{ fontFamily: template.bodyFont, fontSize: '10.5pt', color: '#1c1c1c', lineHeight: 1.5 }}>
        {data.experience.map((exp, i) => (
          <div key={i} style={{ marginBottom: i === data.experience.length - 1 ? 0 : (template.density === 'compact' ? '0.1in' : '0.16in') }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '0.3in' }}>
              <div style={{ fontWeight: 700, color: '#111' }}>
                {exp.title}
                {exp.company && <span style={{ fontWeight: 400 }}>{' — '}{exp.company}</span>}
                {exp.location && <span style={{ fontWeight: 400, color: '#3a3a3a' }}>{', '}{exp.location}</span>}
              </div>
              <div style={{
                fontVariantNumeric: template.tabularDates ? 'tabular-nums' : 'normal',
                color: '#3a3a3a',
                whiteSpace: 'nowrap',
                fontSize: '10pt',
              }}>
                {[exp.start, exp.end].filter(Boolean).join(' — ')}
              </div>
            </div>
            {template.italicRoles && exp.summary && (
              <div style={{ fontStyle: 'italic', color: '#2b2b2b', margin: '0.03in 0' }}>{exp.summary}</div>
            )}
            {!template.italicRoles && exp.summary && (
              <div style={{ color: '#2b2b2b', margin: '0.03in 0' }}>{exp.summary}</div>
            )}
            {exp.bullets && exp.bullets.length > 0 && (
              <ul style={{ margin: '0.03in 0 0 0', paddingLeft: '0.22in' }}>
                {exp.bullets.map((b, j) => (
                  <li key={j} style={{ marginBottom: '0.02in' }}>{b}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
